var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-style-3",class:_vm.customClass,attrs:{"href":_vm.hrefLink}},[_vm._t("default",function(){return [_vm._v("\n    Pruébalo Gratis\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }